import React from 'react';

const iconClass = 'w-4 h-4 shrink-0';

type IconProps = {
  className?: string;
};

const IconDuplicate: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="8" y="8" width="11" height="11" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1" />
  </svg>
);

const IconTrash: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M3 6h18" />
    <path d="M8 6V4h8v2" />
    <path d="M6 6l1 15h10l1-15" />
    <path d="M10 11v6M14 11v6" />
  </svg>
);

const IconLayers: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 3 3 8l9 5 9-5-9-5Z" />
    <path d="m3 12 9 5 9-5" />
    <path d="m3 16 9 5 9-5" />
  </svg>
);

const IconLock: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="5" y="10" width="14" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
  </svg>
);

const IconUnlock: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="5" y="10" width="14" height="10" rx="2" />
    <path d="M8 10V7a4 4 0 0 1 7.5-2" />
  </svg>
);

const IconEyeOff: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="m3 3 18 18" />
    <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
    <path d="M9.9 4.2A10.8 10.8 0 0 1 12 4c5 0 8.5 4 10 8a13.5 13.5 0 0 1-2.1 3.6" />
    <path d="M6.3 6.3A13.2 13.2 0 0 0 2 12c1.5 4 5 8 10 8 1.5 0 2.9-.4 4.1-1" />
  </svg>
);

const IconEye: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M2 12s3.5-8 10-8 10 8 10 8-3.5 8-10 8-10-8-10-8Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

/** Shared show/hide glyph used across panels, toolbars, and menus. */
const VisibilityIcon: React.FC<{ visible: boolean; className?: string }> = ({
  visible,
  className = iconClass,
}) => (visible ? <IconEye className={className} /> : <IconEyeOff className={className} />);

const IconSliders: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3" />
    <path d="M2 14h4M10 8h4M18 16h4" />
  </svg>
);

const IconDownload: React.FC<IconProps> = ({ className = iconClass }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 3v12" />
    <path d="m7 10 5 5 5-5" />
    <path d="M5 21h14" />
  </svg>
);

export {
  IconDuplicate,
  IconTrash,
  IconLayers,
  IconLock,
  IconUnlock,
  IconEyeOff,
  IconEye,
  VisibilityIcon,
  IconSliders,
  IconDownload,
};
